export const fieldConfigurator = {
  "Overview": {
    "Basic Information": {
      "HOA Name": {
        isVisible: true,
        fieldName: ["name"]
      },
      "HOA Address": {
        isVisible: true,
        fieldName: ["address"]
      },
      "Zip": {
        isVisible: true,
        fieldName: ["zip"]
      },
      "Coordinates": {
        isVisible: true,
        fieldName: ["coordinates"]
      },
      "Master Hoa": {
        isVisible: true,
        fieldName: ["masterHoa","masterHoaId"]
      },
      "Contact Number": {
        isVisible: true,
        fieldName: ["phone"]
      },
      "Email": {
        isVisible: true,
        fieldName: ["email"]
      },
      "HOA Fees": {
        isVisible: true,
        fieldName: ["fees"]
      },
      "Payment Frequency": {
        isVisible: true,
        fieldName: ["paymentFrequency"]
      },
      "HOA Fees Payment Deadline": {
        isVisible: true,
        fieldName: ["hoaFeesPaymentDeadline"]
      },
      "HOA Payment Information": {
        isVisible: true,
        fieldName: ["hoaPaymentInformation"]
      },
      "Board Meeting Schedule": {
        isVisible: true,
        fieldName: ["boardMeetingSchedule"]
      },
      "Property Manager": {
        isVisible:true,
        fieldName: ["propertyManagementCompanyAvailable","propertyManager"],
          "Property Manager Name":{
            isVisible:true,
            fieldName:["propertyManagerName"]
          },
          "Property Manager Company Address":{
            isVisible:true,
            fieldName:["propertyManagerCompanyAddress"]
          },
          "Property Manager Phone":{
            isVisible:true,
            fieldName:["propertyManagerPhone"],
          },
          "Property Manager Email":{
            isVisible:true,
            fieldName:["propertyManagerEmail"],
          },
      }
    },
    "Client Information": {
      "Organization": {
        isVisible: true,
        fieldName: ["hoaClientInfo"]
      },
    },
    "Hoa Events": {
      "Show the added HOA events": {
        isVisible: true,
        fieldName: ["hoaEvents"],
        "Title": {
          isVisible: true,
          fieldName: ["title"]
        },
        "Address": {
          isVisible: true,
          fieldName: ["hoaEventAddress"]
        },
        "Additional Information": {
          isVisible: true,
          fieldName: ["additionalInformation"]
        },
        "Date": {
          isVisible: true,
          fieldName: ["eventDate", "endDate"]
        },
        "Time": {
          isVisible: true,
          fieldName: ["fromTime","toTime"]
        },
        "Newsletter & Notification": {
          isVisible: true,
          fieldName: ["newsLetterNotificationFiles"]
        },
      },
    },
    "Additional Information": {
      "Gate Access Required": {
        isVisible: true,
        fieldName: ["isGateAccessRequired"],
        "Resident Gate Access Requirement": {
          isVisible: true,
          fieldName: ["residentGateAccessRequirement"]
        },
        "Gate Access Permission": {
          isVisible: true,
          fieldName: ["guestAccessPermission"]
        },
        "Gate Access Form": {
          isVisible: true,
          fieldName: ["gateAccessFormFiles"]
        },
      },
      "Portal Access": {
        isVisible: true,
        fieldName: ["isPortalAccessRequired"],
        "HOA Portal Link": {
          isVisible: true,
          fieldName: ["hoaPortalLink"]
        },
        "PMC Portal Link": {
          isVisible: true,
          fieldName: ["pmcPortalLink"]
        },
        "Resident Login": {
          isVisible:true,
          fieldName: ["residentLoginAvailable"]
        },
      },
      "Community Services Available": {
        isVisible: true,
        fieldName: ["isCommunityServiceEnabled"],
        "Community Services": {
          isVisible: true,
          fieldName: ["communityServices"]
        }
      }
    },
  },
  "Procedures": {
    "HOA Registration Renewal Information": {
      "Registration & Renewal Instructions": {
        isVisible: true,
        fieldName: ["registrationAndRenewalInstruction"]
      },
      "Renewal Fee": {
        isVisible: true,
        fieldName: ["renewalFee"]
      },
      "Additional Information": {
        isVisible: true,
        fieldName: ["AdditionalInformationOfRenewalFee"]
      },
    },
    "Hoa Leasing Regulations & Restrictions": {
      "Leasing Regulations & Restrictions": {
        isVisible: true,
        fieldName: ["leasingRegulationsAndRestrictions"]
      },
      "Suggested Keywords": {
        isVisible: true,
        fieldName: ["keywords","categories"]
      },
      "Source Document": {
        isVisible: true,
        fieldName: ["sourceDocuments"]
      },
      "Reference": {
        isVisible: true,
        fieldName: ["reference"]
      },
      "Leasing Cap": {
        isVisible: true,
        fieldName: ["leasingCap"],  
        "Additional Information":{
          isVisible: true,
          fieldName: ["AdditionalInformationOfLeasingCap"]
        }
      },
      "Effective Date of Leasing Restriction": {
        isVisible: true,
        fieldName: ["leasingRestrictionDate", "AdditionalInformationOfDateOfLeasing"]
      },
      "Tenant or Lease Registration/Renewal Form": {
        isVisible: true,
        fieldName: ["tenantLeaseRegistrationRenewalForm"]
      },
      "Registrations Admin Fee": {
        isVisible: true,
        fieldName: ["registrationAddminFee"]
      },
    }
  },
  "Amenities": {
    "New Available Amenities": {
      "Show the added new available amenities": {
        isVisible: true,
        fieldName: ["newAvailableAmenities"],
      "Amenity Type":{
       isVisible: true,
       fieldName: ["amenityType"]   
      },
      "Locations": {
        isVisible: true,
        fieldName: ["locations"],
        "Amenity Name": {
          isVisible: true,
          fieldName: ["amenityName"]
        },
        "Address": {
          isVisible: true,
          fieldName: ["amenityAddress"]
        },
        "Google Coordinates": {
          isVisible: true,
          fieldName: ["googleCoordinates"]
        },
        "Amenity Access Name": {
          isVisible: true,
          fieldName: ["amenityAccessName"]
        },
        "Availability": {
          isVisible: true,
          fieldName: ["availability"]
        },
        "Rules & Regulations": {
          isVisible: true,
          fieldName: ["rulesAndRegulations"]
        },
        "Rules & Regulations Document": {
          isVisible: true,
          fieldName: ["rulesAndRegulationDocuments"]
        },
        "Payment Method": {
          isVisible: true,
          fieldName: ["paymentMethod"]
        },
        "Amenity Photos": {
          isVisible: true,
          fieldName: ["amenityPhotos"]
        },
        "Additional Amenities Documents": {
          isVisible: true,
          fieldName: ["additionalAmenitiesDocument"]
        },
      },
     },
    },
    "Amenity Events": {
      "Show the added amenity events": {
        isVisible: true,
        fieldName: ["amenityEvents"],
        "Title": {
          isVisible: true,
          fieldName: ["title"]
        },
        "Address": {
          isVisible: true,
          fieldName: ["amenityEventAddress"]
        },
        "Additional Information": {
          isVisible: true,
          fieldName: ["additionalInformation"]
        },
        "Date": {
          isVisible: true,
          fieldName: ["eventDate", "endDate"]
        },
        "Time": {
          isVisible: true,
          fieldName: ["fromTime","toTime"]
        },
        "Newsletter & Notification": {
          isVisible: true,
          fieldName: ["newsLetterNotificationFiles"]
        },
        "Selected Amenities": {
          isVisible: true,
          fieldName: ["amenityTags"]
        },
      },
    },
    "Access Information": {
      "Show the added access information": {
        isVisible: true,
        fieldName: ["accessInformation"],
        "Name": {
          isVisible: true,
          fieldName: ["name"]
        },
        "Access Fee": {
          isVisible: true,
          fieldName: ["accessFee"]
        },
        "Access Proceedure": {
          isVisible: true,
          fieldName: ["accessProcedure"]
        },
        "First Fee": {
          isVisible: true,
          fieldName: ["firstFee"]
        },
        "Replacement Fee": {
          isVisible: true,
          fieldName: ["replacementFee"]
        },
        "Payment Form Link": {
          isVisible: true,
          fieldName: ["paymentFormLink"]
        },
        "Get Access Information": {
          isVisible: true,
          fieldName: ["getAccessInformation"]
        },
        "Access Form": {
          isVisible: true,
          fieldName: ["accessForm"]
        },
        "Access Form Link": {
          isVisible: true,
          fieldName: ["accessFormLink"]
        },
      },
    },
  },
  "Violation Regulation": {
    "Basic Information": {
      "Violation Fees (min-max)": {
        isVisible: true,
        fieldName: ["minViolationFees", "maxViolationFees"]
      },
      "Cure Period": {
        isVisible: true,
        fieldName: ["curePeriod", "timeline"]
      },
      "Violation Payment": {
        isVisible: true,
        fieldName: ["violationPayment"]
      },
      "Notification Type": {
        isVisible: true,
        fieldName: ["notificationType"]
      },
      "Preferred Violation Remediation": {
        "Portal":{
          isVisible: true,
          fieldName: ["preferredViolationRemediation","Portal","additionalInfoOfPortal"],
        },
        "Email":{
          isVisible: true,
          fieldName: ["preferredViolationRemediation","Email","additionalInfoOfEmail"],
        },
        "Other":{
          isVisible: true,
          fieldName: ["preferredViolationRemediation","Other","additionalInfoOfOther"],
        },
      },
    },
    "Other Restrictions in Place and Fees": {
      "Grace Period": {
        isVisible: true,
        fieldName: ["gracePeriod", "graceTimeline"]
      },
      "Assessment Fee": {
        isVisible: true,
        fieldName: ["assessmentFee"]
      },
      "Assessment Violation Fee": {
        isVisible: true,
        fieldName: ["assessmentViolationFee","assessmentViolationFeeAdditionalInfo",]
      },
      "Assessment Frequency": {
        isVisible: true,
        fieldName: ["assessmentFrequency"]
      },
    },
    "Landscaping": {
      "Grass Trimming": {
        "Assessment Frequency": {
          isVisible: true,
          fieldName: ["assesmentFrequency", "timeline"]
        },
        "Acceptable Height Of Grass": {
          isVisible: true,
          fieldName: ["acceptableHeightOfGrass", "grassSize"]
        },
        "Grass Type Regulations": {
          isVisible: true,
          fieldName: ["grassTypeRegulations"]
        },
        "Allowed Grass Types": {
          isVisible: true,
          fieldName: ["allowedTypesOfGrass"]
        },
        "Restricted Grass Types":{
          isVisible:true,
          fieldName: ["restrictedTypesOfGrass"]
        },
        "Grass Type Additional Info": {
          isVisible: true,
          fieldName: ["grassTypeAdditionalInfo"]
        },
      },
      "Trees & Shrubbing": {
          "Tree alteration and planting":{
            isVisible:true,
            fieldName:["restrictedOptions","Tree alteration and planting","regulationsOfAlterationAndPlantingOfTrees"]
          },
          "Pruning and trimming":{
            isVisible:true,
            fieldName:["restrictedOptions","Pruning and trimming","regulationsOfPruningTrimming"]
          },
          "Vegetation obstructing the view for other residents":{
            isVisible:true,
            fieldName:["restrictedOptions","Vegetation obstructing the view for other residents","regulationsOfVegetationObstructingResidents"]
          },
        "Canopy Measurements": {
          isVisible: true,
          fieldName: ["canopyHeight", "canopySize"]
        },
      },
      "Soil Erosion": {
          "Mulch Replenishing": {
            isVisible: true,
            fieldName: ["mandatoryOptions", "regulationsOfMulchReplenishing", "Mulch Replenishing"]
          },
          "Irrigation maintenance and stain prevention": {
            isVisible: true,
            fieldName: ["mandatoryOptions", "regulationsOfIrrigationMaintenanceAndStainPrevention", "Irrigation maintenance and stain prevention"]
          },
          "Fertilization": {
            isVisible: true,
            fieldName: ["mandatoryOptions", "regulationsOfFertilization", "Fertilization"]
          },
          "Maintenance of Paved/Concrete Surfaces": {
            isVisible: true,
            fieldName: ["mandatoryOptions","Maintenance of Paved/Concrete Surfaces"]
          },
          "Weeding": {
            isVisible: true,
            fieldName: ["mandatoryOptions","Weeding"]
          },
      },
    },
    "Trash": {
      "Storage of Trash": {
          "Trash can on driveway, balcony, or patio": {
            isVisible: true,
            fieldName: ["storageOfWaste","Trash can on driveway, balcony, or patio","regulationsOfTrashCansDrivewayBalconyOrPatio"]
          },
          "Maintenance of Trash": {
            isVisible: true,
            fieldName: ["storageOfWaste","Maintenance of Trash","regulationsOfMaintenanceTrashCans"]
          },
      },
      "Visible Waste": {
          "Trash visibility restrictions from neighboring properties": {
            isVisible: true,
            fieldName: ["visibleWaste", "Trash visibility restrictions from neighboring properties"]
          },
          "Outside Burning of Trash": {
            isVisible: true,
            fieldName: ["visibleWaste", "regulationsOfOutsideBurningTrash","Outside Burning of Trash"]
          },
      },
      "Trash Collection": {
        "Specific Garbage Cans": {
          isVisible: true,
          fieldName: ["isSpecificGarbageCansMandatory", "typesOfTrashCans"]
        },
        "Time of Placing Garbage Cans": {
          isVisible: true,
          fieldName: ["placingTime", "hour","toHour","fromHour", "fromTimeSelection", "toTimeSelection", "toDaySelection", "fromDaySelection","timeOfPlacingGarbageCans", "regulationOfTimeOfPlacingGarbageCans"]
        },
      },
    },
    "Parking": {
      "Street Parking": {
        "Street parking is not allowed": {
          isVisible: true,
          fieldName: ["isStateParkingNotAllowed"]
        },
        "Type of cars not allowed": {
          isVisible: true,
          fieldName: ["notAllowedCarTypes"]
        },
        "Prior Approval Needed For Street Parking": {
          isVisible: true,
          fieldName: ["priorApprovalNeededForStreetParking"]
        },
        "Time Limit For Street Parking": {
          isVisible: true,
          fieldName: ["timeLimitForStreetParking"]
        },
        "Speed Limit Inside HOA": {
          isVisible: true,
          fieldName: ["speedLimitInsideHoa"]
        },
      },
      "Driveway Parking": {
        "Numbers Of Cars Allowed On Lot": {
          isVisible: true,
          fieldName: ["numberOfCarsAllowedOnLot", "regulationsOfnumberOfCarsAllowed"]
        },
        "Garage Capacity": {
          isVisible: true,
          fieldName: ["garageCapacity", "regulationsOfgarageCapacity"]
        },
          "Blocking Sidewalk": {
            isVisible: true,
            fieldName: ["drivewayParkingRestrictedOptions", "Blocking Sidewalk"]
          },
          "Open Garage Doors": {
            isVisible: true,
            fieldName: ["drivewayParkingRestrictedOptions", "Open Garage Doors"]
          },
          "Repair and Maintenance of Cars": {
            isVisible: true,
            fieldName: ["drivewayParkingRestrictedOptions", "regulationsOfRepairMaintenanceOfCars","Repair and Maintenance of Cars"]
          },
          "Garage Sales": {
            isVisible: true,
            fieldName: ["drivewayParkingRestrictedOptions", "Garage Sales","regulationsOfGarageSales"]
          },
          "Parking on common areas": {
            isVisible: true,
            fieldName: ["drivewayParkingRestrictedOptions", "Parking on common areas"]
          },
      },
      "Unlicensed Vehicle": {
          "Commercial Vehicles":{
            isVisible: true,
            fieldName: ["unlicensedVehicleRestrictedOptions", "Commercial Vehicles","typesOfCommercialVehicle"]
          },
        "Prohibited Vehicles": {
          isVisible: true,
          fieldName: ["regulationsOfProhibitedVehicle", "prohibitedVehicles"]
        },
      },
    },
    "Nuisance": {
      "Loud Residents": {
        "Allowed Occupancy Of Guests": {
          isVisible: true,
          fieldName: ["allowedOccupancyOfGuests", "regulationsOfGuests"]
        },
      },
      "Animals": {
        "Animal Regulations and Commercial Use": {
          isVisible: true,
          fieldName: ["loudAnimalsRestrictedOptions", "Animal Regulations and Commercial Use", "regulationOfAnimalsCommercial"]
        },
        "Unleashed Animals": {
          isVisible: true,
          fieldName: ["loudAnimalsRestrictedOptions", "Unleashed Animals"]
        },
        "Dog Houses": {
          isVisible: true,
          fieldName: ["loudAnimalsRestrictedOptions", "regulationsOfDogHouses", "Dog Houses"]
        },
        "Pet Excrements": {
          isVisible: true,
          fieldName: ["loudAnimalsRestrictedOptions", "Pet Excrements"]
        }
      },
      "Offensive Behaviors": {
        "Interfering with peaceful possession": {
          isVisible: true,
          fieldName: ["offensiveBehaviorRestrictedOptions", "Interfering with peaceful possession"]
        },
        "Discharge of Firearms": {
          isVisible: true,
          fieldName: ["offensiveBehaviorRestrictedOptions", "regulationsOfDischargeOfFirearms", "Discharge of Firearms"]
        },
        "Objects emitting loud noise, noxious odors": {
          isVisible: true,
          fieldName: ["offensiveBehaviorRestrictedOptions","regulationsOfNoise", "Objects emitting loud noise, noxious odors"]
        },
        "Business or commercial use of property": {
          isVisible: true,
          fieldName: ["offensiveBehaviorRestrictedOptions", "Business or commercial use of property"]
        },
        "Drying of clothing in or around the property": {
          isVisible: true,
          fieldName: ["offensiveBehaviorRestrictedOptions", "Drying of clothing in or around the property"]
        },
        "Celebration of certain festivals": {
          isVisible: true,
          fieldName: ["offensiveBehaviorRestrictedOptions", "Celebration of certain festivals", "instructionsOfCelebrationCertainFestivals"]
        },
      },
    },
    "Structure": {
      "Alteration": {
        "Painting": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "regulationsOfPainting", "Painting"]
        },
        "Fence": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "regulationsOfFence", "Fence"]
        },
        "Lighting": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Lighting", "regulationsOfLighting"]
        },
        "Garage/Driveway": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Garage/Driveway", "regulationsOfGarageDriveway"]
        },
        "Paved Surface": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Paved Surface", "regulationsOfPavedSurface"]
        },
        "Swimming Pool": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Swimming Pool", "regulationsOfSwimmingPool"]
        },
        "Playscape": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Playscape", "regulationsOfPlayscape"]
        },
        "Secondary Structure": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Secondary Structure", "regulationsOfSecondaryStructure"]
        },
        "Antennas and Satellite Dishes": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Antennas and Satellite Dishes", "regulationsOfAntennasSatelliteDishes"]
        },
        "Mailboxes": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Mailboxes", "regulationsOfMailboxes"]
        },
        "Oiling, Excavations and Mining/ Rainwater Harvesting System": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Oiling, Excavations and Mining/ Rainwater Harvesting System", "regulationsOfOilingExcavationsMiningRainwaterHarvestingSystem"]
        },
        "Flags and Flag poles": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Flags and Flag poles", "regulationsOffLagsFlagPoles"]
        },
        "Water Features/ Wells and Septic Tanks": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Water Features/ Wells and Septic Tanks", "regulationsOfWaterFeaturesWellsSepticTanks"]
        },
        "Siding and Exterior Cladding": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Siding and Exterior Cladding", "regulationsOfSidingExteriorCladding"]
        },
        "Windows / Sun Screens / Screen Doors": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Windows / Sun Screens / Screen Doors", "regulationsOfWindowsSunScreensScreenDoors"]
        },
        "Security Devices": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Security Devices", "regulationsOfSecurityDevices"]
        },
        "Courtyard": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Courtyard", "regulationsOfCourtyard"]
        },
        "Lawn Art & Outdoor Furniture": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Lawn Art & Outdoor Furniture", "regulationsOflLawnArtOutdoorFurniture"]
        },
        "Storage Tanks": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Storage Tanks", "regulationsOfStorageTanks"]
        },
        "Solar Panels": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Solar Panels", "regulationsOfSolarPanels"]
        },
        "Air Conditioning": {
          isVisible: true,
          fieldName: ["regulatedAlterationsOptions", "Air Conditioning", "regulationsOfAirConditioning"]
        },
      },
      "Building": {
        "Structure Change Files": {
          isVisible: true,
          fieldName: ["structureChangeFiles", "structureHyperLink"]
        },
        "Structure Hyper Link": {
          isVisible: true,
          fieldName: ["structureHyperLink"]
        },
        "Planning & Building Department Details": {
          "Email Address": {
            isVisible: true,
            fieldName: ["email"]
          },
          "Phone Number": {
            isVisible: true,
            fieldName: ["phone"]
          },
        "Architectural Files": {
          isVisible: true,
          fieldName: ["architecturalFiles"]
        },
        "Architecture Hyper Link": {
          isVisible: true,
          fieldName: ["architectureHyperLink"]
        },
        "Architectural Instructions": {
          isVisible: true,
          fieldName: ["instructions"]
        }
      },
      },
      "Maintanace": {
        "Broken/Deteriorating Structure": {
          isVisible: true,
          fieldName: ["regulatedMaintenanceOptions","Broken/Deteriorating Structure","regulationsOfBrokenDeterioratingStructure"]
        },
        "Roof/Soffit/Fascia": {
          isVisible: true,
          fieldName: ["regulatedMaintenanceOptions","Roof/Soffit/Fascia","regulationsOfRoofSoffitFascia"]
        },
        "Patio & Deck": {
          isVisible: true,
          fieldName: ["regulatedMaintenanceOptions","Patio & Deck","regulationsOfPatioDeck"]
        },
        "Outdoor Kitchen":{
          isVisible: true,
          fieldName: ["regulatedMaintenanceOptions","Outdoor Kitchen","regulationsOfOutdoorKitchen"]
        },
        "Windows & Awnings": {
          isVisible: true,
          fieldName: ["regulatedMaintenanceOptions","Windows & Awnings","regulationsOfWindowsAwnings"]
        },
        "Pressure Washing": {
          isVisible: true,
          fieldName: ["regulatedMaintenanceOptions","Pressure Washing","regulationsOfPressureWashing"]
        },
        "Irrigation Systems": {
          isVisible: true,
          fieldName: ["regulatedMaintenanceOptions","Irrigation Systems","regulationsOfIrrigationSystems"]
        },
        "Drainage": {
          isVisible: true,
          fieldName: ["regulatedMaintenanceOptions","Drainage","regulationsOfDrainage"]
        },
        "Displaying signs, posters, billboards or advertising": {
          isVisible: true,
          fieldName: ["regulatedMaintenanceOptions","Displaying signs, posters, billboards or advertising","regulationsOfSignsAdvertising"]
        },
        "Yard Lights": {
          isVisible: true,
          fieldName: ["regulatedMaintenanceOptions","Yard Lights","regulationsOfYardLights"]
        },
      },
    },
    "Others": {
      "Other restrictions for the HOA": {
        isVisible: true,
        fieldName: ["others"]
      },
    }

  },
  "Documents": {
    "All Documents": {
      "CCNR Document": {
        isVisible: true,
        fieldName: ["CCNR Document"]
      },
      "By-laws Document": {
        isVisible: true,
        fieldName: ["By-laws Document"]
      },
      "Rules and Restrictions": {
        isVisible: true,
        fieldName: ["Rules and Restrictions"]
      },
      "Articles of Incorporation": {
        isVisible: true,
        fieldName: ["Articles of Incorporation"]
      },
      "HOA Tenant or Lease Registration/Renewal Form": {
        isVisible: true,
        fieldName: ["HOA Tenant or Lease Registration/Renewal Form"]
      },
      "Other Documents": {
        isVisible: true,
        fieldName: ["Other Documents"]
      },
      "Guidelines & Policies": {
        isVisible: true,
        fieldName: ["Guidelines & Policies"]
      },
      "Plat Maps": {
        isVisible: true,
        fieldName: ["Plat Maps"]
      },
      "HOA Updates & Announcements": {
        isVisible: true,
        fieldName: ["HOA Updates & Announcements"]
      },
      "HOA Forms": {
        isVisible: true,
        fieldName: ["HOA Forms"]
      },
    }
  }
}
